import { UserStatusDto } from "./api/UserStatusDto";
import { UserStatus } from "./InMeetingAppService";

export class UserStatusFromResponse {
    constructor(private userStatusFromResponse: UserStatusDto) {}

    userStatus(): UserStatus {
        return {
            hasEnoughOneDriveSpaceToRecord: this.userStatusFromResponse.hasEnoughOneDriveSpaceToRecord,
            organizerIsRecording: true,
        };
    }
}
